import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SignIn from '../views/SignIn'
import IagSettings from '../views/IagSettings'
import CageConfig from '../views/CageConfig'
import DissectConfig from '../views/DissectConfig'
import FixedParmConfig from '../views/FixedParmConfig'
import IndexConfig from '../views/IndexConfig'
import ProportionConfig from '../views/ProportionConfig'

Vue.use(VueRouter)

const routes = [
  {
    path: '/signin',
    name: 'signin',
    component: SignIn
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/cage',
    name: 'cage',
    component: CageConfig
  },
  {
    path: '/dissect',
    name: 'dissect',
    component: DissectConfig
  },
  {
    path: '/fixedParam',
    name: 'fixedParam',
    component: FixedParmConfig
  },
  {
    path: '/index',
    name: 'index',
    component: IndexConfig
  },
  {
    path: '/proportion',
    name: 'proportion',
    component: ProportionConfig
  },
  {
    path: '/settings',
    name: 'Settings',
    component: IagSettings
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
